import { useEffect, useState } from "react";
import { phoneScreen } from "../game/hill";

/** Whether this is a phone-sized screen (#198, `phoneScreen`), following resizes and turns. */
export function usePhoneScreen(touch: boolean): boolean {
  const [phone, setPhone] = useState(() => phoneScreen(touch, window.innerHeight));
  useEffect(() => {
    const fit = () => setPhone(phoneScreen(touch, window.innerHeight));
    fit();
    window.addEventListener("resize", fit);
    return () => window.removeEventListener("resize", fit);
  }, [touch]);
  return phone;
}
